import apiHandler from "../../utilities/apiHandler.js";

const LoginApiHandler = {
	loginWithToken: function (req) {
		var URL = "api/credit/gateway/login/validate-token";
		return apiHandler.post(URL, req);
	}
};
export default LoginApiHandler;



// WEBPACK FOOTER //
// ./src/screens/login/LoginApiHandler.js